import React from "react";

export default function Copyright() {
	return (
		<div style={{ height: "auto" }}>
				<span style={{ fontSize: "10px", color: "#b79dff" }}>
					Copyright &copy; {new Date().getFullYear()} All Rights Reserved by Uplyft Capital &nbsp; • &nbsp;
					<a href='https://uplyftcapital.com/about-us/'><span style={{ fontSize: "10px", color: "#3a237a", textDecoration: "underLine" }}>About Us</span></a>
					&nbsp; • &nbsp;
					<a href='https://uplyftcapital.com/terms-of-use/'><span style={{ fontSize: "10px", color: "#3a237a", textDecoration: "underLine" }}>Terms of Use</span></a>
					&nbsp; • &nbsp;
					<a href='https://uplyftcapital.com/privacy-policy/'><span style={{ fontSize: "10px", color: "#3a237a", textDecoration: "underLine" }}>Privacy Policy</span></a>
					&nbsp; • &nbsp;
					Call: 1(800) 515-7531 &nbsp; • &nbsp; 499 E Sheridan Street Suite 300, Dania Beach, FL 33004-5501
				</span>
		</div>
	);
}